import React from 'react';
import { Badge, BadgeProps } from '@good/ui/core';

interface SignedStatusBadgeProps extends Omit<BadgeProps, 'color'> {
  signed: boolean;
}

export const SignedStatusBadge = ({ signed, ...props }: SignedStatusBadgeProps) => {
  if (signed) {
    return (
      <Badge variant='dot' {...props} color='green'>
        Signed
      </Badge>
    );
  }

  return (
    <Badge variant='dot' {...props} color='red'>
      Not signed
    </Badge>
  );
};
